<template>
  <div>
    <div class="row">
      <div class="col-sm-12 padding-top">
        <div class="panel panel-default">
          <div
            class="panel-heading"
            @click.prevent="collapsed = !collapsed"
            style="cursor: pointer;"
          >
            <a href="#">
              <i class="fa" :class="{ 'fa-plus': collapsed, 'fa-minus': !collapsed }"></i> Regime
              Federal
              <span v-if="pendencias > 0" class="badge bg-red">{{
                pendencias | pluralize('pendência')
              }}</span>
            </a>
          </div>
          <div class="panel-body" v-show="!collapsed">
            <div class="row">
              <div class="col-sm-12">
                <strong>Regime/Vigência</strong>
              </div>
              <hr />
            </div>
            <div class="row">
              <div class="col-sm-3">
                <div class="form-group" :class="{ 'has-error': $v.federal.tipo.$invalid }">
                  <label for="">Regime:</label>
                  <multiselect
                    :options="regimesTipos"
                    :block-keys="['Tab', 'Enter']"
                    @select="onSelectRegime"
                    label="descricao"
                    track-by="id"
                    v-model="federal.tipo"
                    :allow-empty="false"
                    placeholder="Selecione um regime"
                    selectLabel="Selecionar"
                    selectedLabel="Selecionado"
                    deselect-label=""
                    :disabled="$parent.disableAll"
                  ></multiselect>
                  <p class="help-block" v-show="!$v.federal.tipo.descricao.required">
                    Este campo é obrigatório.
                  </p>
                </div>
              </div>
              <div
                class="col-sm-2 my-popover"
                data-content="A Vigência só pode ser alterada após a alteração do Regime"
                data-toggle="popover"
              >
                <div class="form-group" :class="{ 'has-error': $v.federal.vigencia.$invalid }">
                  <label for="">Vigência:</label>
                  <input-data v-model="federal.vigencia" :disabled="$parent.disableAll" />
                  <p class="help-block" v-show="!$v.federal.vigencia.required">
                    Este campo é obrigatório.
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-2">
                <div class="form-group">
                  <label for="">IRPJ:</label>
                  <input-money v-model="federal.irpj" prefix="" :disabled="federal.tipo.id === 1" />
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group">
                  <label for="">CSLL:</label>
                  <input-money v-model="federal.csll" prefix="" :disabled="federal.tipo.id === 1" />
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group">
                  <label for="">PIS:</label>
                  <input-money v-model="federal.pis" prefix="" :disabled="federal.tipo.id === 1" />
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group">
                  <label for="">COFINS:</label>
                  <input-money
                    v-model="federal.cofins"
                    prefix=""
                    :disabled="federal.tipo.id === 1"
                  />
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group">
                  <label for="">Imposto Folha:</label>
                  <input-money v-model="federal.impostosFolha" prefix="" />
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group">
                  <label for="">Fat. Red. IRPJ:</label>
                  <input-money v-model="federal.fatRedIrpj" prefix="" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-2">
                <div class="form-group">
                  <label for="">Fat. Red. CSLL:</label>
                  <input-money v-model="federal.fatRedCsll" prefix="" />
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group">
                  <label for="">Fat. Red. Serviços:</label>
                  <input-money v-model="federal.fatRedServicos" prefix="" />
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group">
                  <label for="">Aliq. Adicional:</label>
                  <input-money v-model="federal.aliqAdicional" prefix="" />
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group">
                  <label for="">Lim. Lucro Mês:</label>
                  <input-money v-model="federal.limiteLucroMes" prefix="" />
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group">
                  <label for="">Aliq. Própria:</label>
                  <input-money v-model="federal.aliqPropriaBasa" prefix="" />
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group">
                  <label for="">Aliq. Base:</label>
                  <input-money v-model="federal.aliqBcBasa" prefix="" />
                </div>
              </div>
            </div>
            <div v-show="federal.tipo.id === 1">
              <div class="row">
                <div class="col-sm-3 table-responsive">
                  <table class="table table-striped table-condensed table-hover">
                    <thead>
                      <tr>
                        <th>Tipo</th>
                        <th>Tabela</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(tabela, idx) in federal.simples.tabelas"
                        v-show="tabela.status !== 'DELETE'"
                      >
                        <td>{{ tabela.tipo.id | tabelaTipo }}</td>
                        <td>{{ tabela.id }}</td>
                        <td>
                          <a
                            href="#"
                            class="text-danger"
                            @click.prevent="removeTabelaSimples(tabela, idx)"
                          >
                            <i class="fa fa-trash-o"></i>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="col-sm-9 table-responsive">
                  <table class="table table-condensed table-striped table-hover">
                    <thead>
                      <tr>
                        <th>De</th>
                        <th>Até</th>
                        <th>Redução</th>
                        <th>Aliq. Simples</th>
                        <th>IRPJ</th>
                        <th>CSLL</th>
                        <th>PIS</th>
                        <th>COFINS</th>
                        <th>CPP</th>
                        <th>ICMS</th>
                        <th>IPI</th>
                        <th>ISS</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(faixa, index) in federal.simples.faixas">
                        <td>{{ faixa.de | currency }}</td>
                        <td>{{ faixa.ate | currency }}</td>
                        <td>{{ faixa.vlReducao | currency }}</td>
                        <td>{{ faixa.aliqSimples }}</td>
                        <td>{{ faixa.irpj }}</td>
                        <td>{{ faixa.csll }}</td>
                        <td>{{ faixa.pis }}</td>
                        <td>{{ faixa.cofins }}</td>
                        <td>{{ faixa.cpp }}</td>
                        <td>{{ faixa.icms }}</td>
                        <td>{{ faixa.ipi }}</td>
                        <td>{{ faixa.iss }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="row" v-if="isNovo">
              <div class="col-sm-12">
                <button
                  class="btn btn-success pull-right"
                  :disabled="pendencias > 0"
                  @click.prevent="updateRegimeFederal"
                >
                  Salvar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Empresa } from '../../models/Empresa'
import { RegimeFederalValidation, RegimeFederalNoValidation } from '../../models/RegimeFederal'
import Multiselect from 'vue-multiselect'
import RegimeService from '../../services/RegimeService'
import EmpresaService from '../../services/EmpresaService'
import InputData from '../../components/Inputs/InputData.vue'
import InputMoney from '../../components/Inputs/InputMoney'

export default {
  name: 'regime-federal',
  props: {
    value: {},
    isNovo: {
      type: Boolean,
      required: true
    },
    ativo: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      collapsed: true,
      federal: new Empresa().regime.federal,
      regimesTipos: [],
      firstWatch: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$set(this.$data, 'empresa', this.value.regime.federal)
    })
    this.$nextTick(() => {
      window.$('.my-popover').popover({
        placement: 'top',
        html: true,
        container: 'body',
        trigger: 'hover'
      })
    })
    this.federal = this.value.regime.federal
    this.retrieveRegimesFederais()
  },
  methods: {
    async updateRegimeFederal() {
      try {
        let empresa = Object.assign({}, this.value)
        empresa.regime.estadual = {}
        empresa.regime.federal = this.federal
        empresa.contato = {}
        empresa.endereco = {}
        empresa.contabilista = {}
        await EmpresaService.update(empresa)
        this.$messages.success().toast('Empresa atualizada com sucesso!')
        this.$router.go(-1)
      } catch (e) {
        this.$messages
          .error(e.message || e.data.message)
          .toast('Não foi possível realizar esta ação')
        console.error(e)
      } finally {
      }
    },

    async retrieveRegimesFederais() {
      try {
        const data = await RegimeService.retrieveRegimesFederais()
        this.regimesTipos = data.body
      } catch (e) {
        this.$messages.error(e.message || e.data.message).toast(e.data)
        console.error(e)
      }
    },

    onSelectRegime() {
      this.federal.status = 'INSERT'
      this.federal.vigencia = ''
    }
  },
  components: {
    Multiselect,
    InputData,
    InputMoney
  },
  computed: {
    pendencias() {
      let counter = Object.entries(this.$v.federal)
        .map(a => a[1])
        .filter(a => a.$invalid).length
      return this.invalidSimples ? counter + 1 : counter
    },

    invalidSimples() {
      return false
    }
  },
  watch: {
    federal: {
      handler: function() {
        if (this.firstWatch) {
          this.firstWatch = false
        } else {
          this.federal.status = 'INSERT'
        }
      },
      deep: true
    },

    value(vl) {
      this.federal = vl.regime.federal
    }
  },
  filters: {
    tabelaTipo(id) {
      const tipos = { '0': 'Comércio', '1': 'Serviço' }
      return tipos[id]
    }
  },
  validations() {
    return {
      federal: this.ativo ? RegimeFederalValidation : RegimeFederalNoValidation
    }
  }
}
</script>

<style lang="css" scoped>
.padding-top {
  padding-top: 10px;
}

.btn-multiselect {
  min-height: 40px;
}

a {
  color: #3c8dbc !important;
}
</style>
